import { requesterFirebaseDesigns } from './requester';
import { CATEGORY_ID_UNAVAILABLE, USER_UNAUTHORIZED } from '../../displayText';
import { ThirdPartyLibraryTile } from '../../types/ThirdPartyLibrary';
import { PatternDesignApi } from '../../types/PatternDesignApiResponse';
import { ImageTilesApi } from '../../types/ImageTilesApiResponse';
import { imgslib } from '../../../redux/reducers/imgslib';
import { fireDir } from '../../../firebase';

export const IMAGES_PER_PAGE = 25;

export const fetchOwnLibraryImages = async (apiKey:string, filters:{filterName:string, filterKey:string}[])=>{
    const firebaseImages = await fetchFirebaseImages(apiKey, filters)
    const imgLib = parseIframeImgLibs(firebaseImages,'vendor','vendor')

    let libLevel = imgLib;

    while(!libLevel.isPatternContainer && libLevel.pagedTiles?.length){
        libLevel = libLevel.pagedTiles[0][0]
    }

    return [libLevel]
}

export const fetchImageCategories = async (args: { requiresAuthorization?: boolean, categoryId?: number | string, patternId?: number | string, iframeImgLibToAdd?: any[] } = {}): Promise<ThirdPartyLibraryTile[]> => {
    const { requiresAuthorization, categoryId, patternId, iframeImgLibToAdd } = args;

    try {

        if (patternId) {
            return await fetchImageTiles({ categoryId: patternId })
        } else {
            const url = getFetchUrl(categoryId)

            const response: PatternDesignApi = await requesterFirebaseDesigns(url);

            const imgLibs: ThirdPartyLibraryTile|undefined = (iframeImgLibToAdd && parseIframeImgLibs(iframeImgLibToAdd))

            return imgLibs?[imgLibs].concat(parseImageCategories(response)):parseImageCategories(response);
        }
    } catch (error) {
        console.error(error)
        throw {
            errorMessage: error.message,
            source: 'patternDesigns'
        }
    }
}

// {"url":"https:\/\/caspar-design.com\/wp-content\/uploads\/2020\/09\/FD0001_01-1.png"
// ,"urlThumbnail":"https:\/\/caspar-design.com\/wp-content\/uploads\/2020\/09\/FD0001_01-1-100x100.png",
// "name":"fd0001_01",
// "id":44624,
// "catName":["Tiles"]}

export type MLImage = {
    url: string,
    urlThumbnail: string,
    name: string,
    id: number,
    catName: string[],
    scaleFactor: number,
    filter?:any
}

export const fetchFirebaseImages = (userId: string, filters:{filterName:string, filterKey:string, options?:string[]}[]):Promise<MLImage[]> => new Promise((resolve, reject) => {
    const mlImages: MLImage[] = []
    const tenantRef = fireDir.doc(userId)
    const mlRootRef = tenantRef.collection("Media")
    mlRootRef
        .get()
        .then(mlRootSnap => {
            let counter = 0
            for (const mldRef of mlRootSnap.docs) {
                const mlSourceRef = mlRootRef.doc(mldRef.id)
                const mlImagesRef = mlSourceRef.collection("Images").orderBy("Name","desc")
                mlImagesRef
                    .get()
                    .then(mlImagesSnap => {
                        for (const mlImageRef of mlImagesSnap.docs) {
                            const mlImage = mlImageRef.data()

                            const id = mlImageRef.id || mlImage.SourceID || counter++

                            let imageTile: MLImage = {
                                catName: mlImage.Categories || ['Early.Vision'],
                                id,
                                url: mlImage.FullSizeURL,
                                //urlThumbnail: mlImage.FullSizeURL,
                                urlThumbnail: mlImage.ThumbURL,
                                scaleFactor: mlImage.ScaleFactor,
                                name: mlImage.Name || id,
                            }

                            filters.forEach((filter)=>{
                                const filterKeyToUse = filter.filterKey.substring(6).toLowerCase(); 
                                const filterOptions = mlImage[filterKeyToUse]
                                // console.log('=======filter='+filterKeyToUse+'====>'+JSON.stringify(filterOptions))
                                if(filterOptions){
                                    if(!imageTile.filter){
                                        imageTile.filter = {}
                                    }

                                    imageTile.filter[filter.filterKey] = filterOptions;

                                    if(!filter.options){
                                        filter.options=[]
                                    }
                                    filterOptions.forEach((option:string) =>{
                                        if(!filter.options?.includes(option)){
                                            filter.options?.push(option)
                                        }
                                    })
                                    
                                }
                            })

                            mlImages.push(imageTile)

                        }
                        resolve(mlImages)
                    })
            }
        })
        .catch(err => {
            reject(err)
        })
})


export const parseIframeImgLibs = (imgsLib: any[], categoryId?:string, categoryName?:string): ThirdPartyLibraryTile => {
    const categorizedTiles: { [key: string]: ThirdPartyLibraryTile } = {}

    imgsLib.forEach((image) => {
        image.catName.forEach((category: string) => {
            if (!categorizedTiles[category]) {
                categorizedTiles[category] = {
                    id: category,
                    name: category,
                    isCategory: true,
                    isPatternContainer: true,
                    thumbnail: {
                        source: image.urlThumbnail
                    },
                    url: image.urlThumbnail,
                    tiles: [],
                    pagedTiles: [[]],
                    isPatternDesign: false,
                    scaleFactor: image.scaleFactor
                }
            }
            const tile: ThirdPartyLibraryTile = {
                id: image.id,
                name: image.name,
                isCategory: false,
                isPatternContainer: false,
                filter: image.filter,
                thumbnail: {
                    source: image.urlThumbnail
                },
                url: image.url,
                isPatternDesign: false,
                scaleFactor: image.scaleFactor
            }

            const { pagedTiles } = categorizedTiles[category]
            if (pagedTiles && pagedTiles[pagedTiles.length - 1].length < 1000) {
                pagedTiles[pagedTiles.length - 1].push(tile)
            } else if (pagedTiles) {
                pagedTiles.push([tile])
            }

            categorizedTiles[category].tiles = pagedTiles?.length && pagedTiles[0]||[];

        })
    })

    const tiles: ThirdPartyLibraryTile[] = []

    for (const key in categorizedTiles) {
        if (Object.prototype.hasOwnProperty.call(categorizedTiles, key)) {
            const { pagedTiles } = categorizedTiles[key]
            const lastTileArray = pagedTiles && pagedTiles[pagedTiles?.length-1]
            const lastArrayElement = lastTileArray && lastTileArray[lastTileArray.length -1]
            
            lastArrayElement && (lastArrayElement.isLastElement = true);

            if (pagedTiles && pagedTiles.length) {
                const tileList = pagedTiles[0]

                tiles.push({
                    id: key,
                    name: key,
                    isCategory: true,
                    isPatternContainer: true,
                    thumbnail: tileList[0].thumbnail,
                    url: tileList[0].url,
                    pagedTiles,
                    tiles: tileList,
                    isPatternDesign: false,
                    scaleFactor: tileList[0].scaleFactor
                })
            }
        }
    }

    return {
        id: categoryId||'Master',
        name: categoryName||'Master',
        isCategory: true,
        isPatternContainer: false,
        thumbnail: {
            source: imgsLib[0].urlThumbnail
        },
        url: imgsLib[0].urlThumbnail,
        tiles,
        pagedTiles: [tiles],
        isPatternDesign: false,
        scaleFactor: imgsLib[0].scaleFactor
    }
}

export const fetchImageTiles = async (args: { 
    requiresAuthorization?: boolean, 
    categoryId?: number|string, 
    offset?: number,
    term?: string
} = {}) => {
    const { requiresAuthorization, categoryId, offset = 0, term } = args;
    try {
        const isAuthorized = true

        if (isAuthorized) {
            const url = (term)?
                `https://us-central1-evpatterndesign.cloudfunctions.net/getPatterns/?ck=gsSmbQHt7mvqjIY2baAwMEmS&term=${term}&nor=${IMAGES_PER_PAGE}&offset=${IMAGES_PER_PAGE * offset}` :
                `https://us-central1-evpatterndesign.cloudfunctions.net/getPatterns/?ck=gsSmbQHt7mvqjIY2baAwMEmS&tlc=${categoryId}&nor=${IMAGES_PER_PAGE}&offset=${IMAGES_PER_PAGE * offset}`;

            const response: ImageTilesApi = await requesterFirebaseDesigns(url);

            return parseImages(response);
        } else {
            throw new Error(USER_UNAUTHORIZED)
        }
    } catch (error) {
        throw {
            errorMessage: error.message,
            source: 'patternDesigns'
        }
    }
}

export const parseImages = (response: ImageTilesApi): ThirdPartyLibraryTile[] => {
    return response.patterns.map(pattern => ({
        id: pattern.id,
        isCategory: false,
        isPatternContainer: false,
        scaleFactor: pattern.scaleFactor || 1,
        isPatternDesign: true,
        name: pattern.title,
        thumbnail: {
            source: pattern.thumbnails.small.url
        },
        url: pattern.thumbnails.xlarge.url,
    }))
}

export const parseImageCategories = (response: PatternDesignApi): ThirdPartyLibraryTile[] => {
    console.log(response)
    return response.categories.map(category => ({
        id: category.id,
        isPatternDesign: true,
        scaleFactor: category.scaleFactor || 1,
        isCategory: true,
        isPatternContainer: category.containsPatterns,
        name: category.title,
        thumbnail: {
            source: category.thumbnail
        },
        url: category.thumbnail
    }))
}

export const getFetchUrl = (categoryId?: number|string) => {
    return categoryId === 'evroot' ?
        'https://us-central1-evpatterndesign.cloudfunctions.net/getCategories/?ck=gsSmbQHt7mvqjIY2baAwMEmS':
        categoryId ? `https://us-central1-evpatterndesign.cloudfunctions.net/getCategories/?ck=gsSmbQHt7mvqjIY2baAwMEmS&tlc=${categoryId}`:
        'https://us-central1-evpatterndesign.cloudfunctions.net/getCategories/?ck=gsSmbQHt7mvqjIY2baAwMEmS'
}


